var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-square 2",
    clipPath: "url(#clip0_6448_7163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12V24H12.5H24.5V12V0H12.5H0.5V12ZM2.29147 12V22.2085H12.5H22.7085V12V1.79147H12.5H2.29147V12ZM8.04968 7.56407L7.42448 8.18974L9.32947 10.0949L11.2344 12L9.32938 13.9052L7.42434 15.8104L8.05696 16.443L8.68957 17.0757L10.5948 15.1706L12.5 13.2656L14.4052 15.1706L16.3104 17.0757L16.943 16.443L17.5757 15.8104L15.6706 13.9052L13.7656 12L15.6706 10.0948L17.5757 8.18957L16.943 7.55696L16.3104 6.92434L14.4052 8.82938L12.5 10.7344L10.6018 8.83641C9.55781 7.79249 8.69717 6.93839 8.68926 6.93839C8.68136 6.93839 8.39353 7.21993 8.04968 7.56407Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6448_7163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorOutline);
export default __webpack_public_path__ + "static/media/icon--error-outline.a17c70e2404628e9905dccb8c3a5b138.svg";
export { ForwardRef as ReactComponent };